export const AVAILABLE_STATUSES = ["OpenedProspect", "ArchievedProspect", "AssignedProspect"];

export const DEFAULT_PAGINATION_CONFIG = { current: 1, pageSize: 10 };
